import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { DailyScheduleTimeRange } from "./daily-schedule-time-range";
import { dailyScheduleTimeRangeZodSchema } from "./daily-schedule-time-range";
import type { TimePadding } from "./time-padding";
import { timePaddingZodSchema } from "./time-padding";

type DailySchedule = {
    _id: string;
    timeRange: DailyScheduleTimeRange;
    orderTimePadding?: TimePadding;
};

const dailyScheduleZodSchema: z.ZodSchema<DailySchedule> = z.object({
    _id: z.string(),
    timeRange: dailyScheduleTimeRangeZodSchema,
    orderTimePadding: timePaddingZodSchema.optional(),
});

const dailyScheduleFactory = (
    params: Except<DailySchedule, "_id">,
): DailySchedule => ({
    _id: generateId({ prefix: "daily_schedule__" }),
    ...params,
});

export { dailyScheduleFactory, dailyScheduleZodSchema };
export type { DailySchedule };
